<template lang="pug">
#receipts
    v-banner.title-banner(min-height="88")
        .text-h4.font-weight-bold {{ this.$t('Menu.__Purchase') + ' : ' + this.$t('Menu.__Receipt') }}
        template(v-slot:actions)
            v-btn.ml-6(rounded, color="primary", @click="editItem(null)") {{ $t('Receipts.__AddReceipt') }}

    v-container
        .action-bar.mb-8
            v-row
                v-spacer
                v-col(cols="12" md="3")
                    v-menu(
                        v-model="rangeDateMenu",
                        offset-y,
                        :close-on-content-click="false",
                        :nudge-right="40",
                        transition="scale-transition",
                        min-width="290px"
                    )
                        template(v-slot:activator="{ on }")
                            v-text-field(
                                :value="dateRangeText",
                                clearable,
                                hide-details,
                                solo,
                                dense,
                                outlined,
                                readonly,
                                append-icon="event",
                                v-on="on",
                                :placeholder="$t('Placeholder.__DateRange')",
                                @click:clear="dates = []"
                            )
                        v-date-picker(
                            v-model="dates",
                            @input="rangeDateMenu = dates.length == 2 ? false : true",
                            :locale="$store.getters['account/language']() == 'tw'? 'zn-tw': ''",
                            range
                        )
        Alert
        ConfirmDialog(
            v-model="deleteDialog",
            :title="$t('Receipts.__DeleteReceipt')",
            :message="$t('Receipts.__ConfirmDeleteReceipt')",
            :cancel-text="$t('ActionOption.__Cancel')",
            :confirm-text="$t('ActionOption.__Delete')",
            :confirm-action="deleteReceipt"
        )
        ReceiptDialog(
            v-model="receiptDialog",
            :receipt-id="selectedId",
            :confirm-action="editDone",
            :is-view="isView"
        )

        v-data-table.mb-6(:headers="headers" :items="receipts" hide-default-footer :options.sync="options" :loading="loading" :custom-sort="defaultDataSort") 
            //- template(v-slot:item.vendor="{item}")
            //-     .vendor-name {{item.vendor.name}}
            //- template(v-slot:item.status="{item}")
            //-     v-chip(dark small :color="getStatusColor(item.status)") {{item.status}}
            template(v-slot:item.total="{ item }")
                .total {{ getAmountWithCurrency(item.total, currencyCode) }}
                //- .total-amount {{ item.currency.symbol }} {{item.total}}
            template(v-slot:item.entryAccount="{ item }")
                .account {{ getAccountTranslatedName(item.entryAccount.name) }}
            template(v-slot:item.paymentAccount="{ item }")
                .account {{ getAccountTranslatedName(item.paymentAccount.name) }}

            template(v-slot:item.actions="{ item }")
                //- v-btn(text color="primary")  記錄付款資訊
                v-menu(bottom, left)
                    template(v-slot:activator="{ on }")
                        v-btn(icon, v-on="on")
                            v-icon(outlined, color="gray") keyboard_arrow_down
                    v-list
                        template(v-for="(menu, i) in actionItems")
                            v-list-item(:key="i", @click="menu.click(item)")
                                v-list-item-title {{ menu.title }}
                            v-divider(v-if="menu.divider")

        v-row.pagination-row
            v-col.d-flex.align-center.justify-start(cols="6")
                span.mr-2.d-none.d-md-block {{ $t('Table.__ItemsPerPage') }}
                span
                    v-select.page-select(
                        v-model="options.itemsPerPage",
                        solo,
                        dense,
                        outlined,
                        hide-details,
                        :items="perPageItems"
                    )
            v-col.d-flex.justify-end(cols="6")
                v-pagination(v-model="options.page", :length="pageCount")
</template>
<script>
import * as currencyHelper from "@/utils/currencies"
import * as TimeHelper from "@/utils/timeHelper"
import ReceiptDialog from "@/components/ReceiptDialog"
import * as accountHelper from "@/utils/accountHelper"
import * as datatableHelper from "@/utils/datatableHelper.js"

export default {
  props: ["alert"],
  components: { ReceiptDialog },
  mixins: [currencyHelper.mixin, TimeHelper.mixin, accountHelper.mixin, datatableHelper.mixin],
  data() {
    return {
      perPageItems: [10, 25, 50],
      pageCount: 0,
      options: { page: 1, itemsPerPage: 10, sortBy: [], sortDesc: [] },
      loading: false,
      filters: {},

      actionItems: [
        {
          title: this.$t("ActionOption.__View"),
          divider: true,
          click: this.viewItem
        },
        {
          title: this.$t("ActionOption.__Edit"),
          divider: true,
          click: this.editItem
        },
        // { title: "編輯", click: this.editItem },
        // { title: "複製", divider: true, click: this.duplicateItem },
        {
          title: this.$t("ActionOption.__Delete"),
          click: this.deleteItem
        }
      ],
      isView: false,
      receiptDialog: false,
      deleteDialog: false,
      deleteId: null,
      selectedId: null,
      selectedVendor: null,
      rangeDateMenu: false,
      dates: [],
      sortedDate: [],
      searchText: "",
      headers: [
        {
          text: this.$t("Receipts.__Date"),
          align: "start",
          sortable: true,
          value: "date"
        },
        {
          text: this.$t("Receipts.__Merchant"),
          align: "start",
          sortable: true,
          value: "merchantName"
        },
        {
          text: this.$t("Receipts.__ExpenseAccount"),
          align: "start",
          sortable: false,
          value: "entryAccount"
        },
        {
          text: this.$t("Receipts.__PaymentAccount"),
          align: "start",
          sortable: false,
          value: "paymentAccount"
        },
        {
          text: this.$t("Receipts.__AfterTaxAmount"),
          align: "end",
          sortable: true,
          value: "total"
        },
        {
          text: "",
          align: "center",
          width: "200px",
          sortable: false,
          value: "actions"
        }
      ],
      // filteredReceipts: [],
      receipts: [
        // {
        //     id: "N2alzW2e",
        //     status: "READY",
        //     merchantName: "new merchant",
        //     date: "2020-06-06",
        //     currencyCode: "TWD",
        //     total: 67.89
        // },
        // {
        //     id: "CIrceBKX",
        //     status: "READY",
        //     merchantName: "new merchant",
        //     date: "2020-06-06",
        //     currencyCode: "TWD",
        //     total: 67.89
        // }
      ]
    }
  },
  watch: {
    dates(value) {
      if (this.dates.length > 0) {
        this.filters.from = this.dates[0]
        this.filters.to = this.dates.length == 2 ? this.dates[1] : this.dates[0]
      } else {
        delete this.filters["from"]
        delete this.filters["to"]
      }
      this.getReceipts()
    },
    selectedVendor(value) {
      this.getReceipts()
    },
    options: {
      handler() {
        this.getReceipts()
      },
      deep: true
    }
  },
  methods: {
    // filterReceipts() {
    //     this.filteredReceipts = this.receipts
    //     // this.filteredReceipts = this.filteredReceipts.filter(item => {
    //     //     return this.customer == null
    //     //         ? true
    //     //         : item.customer.id == this.customer.id
    //     // })
    //     this.filteredReceipts = this.filteredReceipts.filter(item => {
    //         if (this.dates.length == 0) return true
    //         var dates = this.dates.slice().sort()
    //         var targetTimestamp = this.date2unixtimestamp(item.date)
    //         var date1Timestamp = this.date2unixtimestamp(dates[0])
    //         var date2Timestamp = dates[1]
    //             ? this.date2unixtimestamp(dates[1])
    //             : 0
    //         return this.dates.length == 1
    //             ? targetTimestamp == date1Timestamp
    //             : targetTimestamp >= date1Timestamp &&
    //                   targetTimestamp <= date2Timestamp
    //     })
    // },
    getReceipts() {
      var query = this.datatableOptionsToQuery(this.options)
      query = Object.assign({}, query, this.filters)
      this.loading = true
      // this.$store.dispatch("global/startLoading")
      this.$store
        .dispatch("receipts/getReceipts", query)
        .then(
          function(response) {
            this.receipts = response.data
            this.pageCount = response.paging.totalPages
            this.loading = false
            // this.$store.dispatch("global/stopLoading")
          }.bind(this)
        )
        .catch(
          function(error) {
            this.loading = false
            // this.$store.dispatch("global/stopLoading")
          }.bind(this)
        )
    },
    viewItem(item) {
      this.isView = true
      this.selectedId = item.id
      this.receiptDialog = true
    },
    editItem(item) {
      this.isView = false
      if (item != null) {
        this.selectedId = item.id
      } else {
        this.selectedId = null
      }

      this.receiptDialog = true
    },
    editDone() {
      this.receiptDialog = false
      this.getReceipts()
    },
    deleteItem(item) {
      this.deleteDialog = true
      this.deleteId = item.id
    },
    deleteReceipt() {
      this.$store.dispatch("global/startLoading")
      this.$store
        .dispatch("receipts/deleteReceipt", this.deleteId)
        .then(
          function(response) {
            this.getReceipts()
            this.$store.dispatch("global/showAlertSuccess", this.$t("Messages.__SuccessfullyDeleted"))
          }.bind(this)
        )
        .catch(
          function(error) {
            this.$store.dispatch("global/showAlertError", error.message)
          }.bind(this)
        )
      this.deleteDialog = false
    },
    getStatusColor(status) {
      for (var item of this.statusItems) {
        if (item.text == status) {
          return item.color
        }
      }
    }
  },
  computed: {
    dateRangeText() {
      return this.dates
        .slice()
        .sort()
        .join(" ~ ")
    }
    // vendors() {
    //     return this.receipts.map(function(reciept) {
    //         return { id: reciept.vendor.id, name: reciept.vendor.name }
    //     })
    // }
  },
  mounted() {
    var receiptId = this.$route.query.id
    if (receiptId) {
      this.isView = true
      this.selectedId = receiptId
      this.receiptDialog = true
    }
    if (this.alert) {
      this.$store.dispatch("global/showAlert", this.alert)
    }
  },
  created() {
    // this.getReceipts()
    // this.filteredReceipts = this.receipts
  }
}
</script>
<style lang="scss" scoped>
@import "@/assets/scss/formcontrol.scss";
</style>
